var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 448,
    viewBox: "0 0 128 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08264 1.48931C7.25564 2.39631 4.55564 4.72031 3.08264 6.65231L0.402646 10.1653L0.145642 222.577C-0.140358 459.288 -0.742351 438.939 6.71565 444.627L10.2466 447.321H63.9026H117.559L121.09 444.627C128.522 438.959 127.903 459.031 127.903 223.821C127.903 -11.3867 128.522 8.68431 121.091 3.01531L117.56 0.321311L64.9817 0.08031C17.8177 -0.13669 12.0606 0.00931036 9.08264 1.48931ZM68.6977 20.5713C72.0287 23.4623 103.903 66.7703 103.903 68.4053C103.903 70.7833 101.144 75.5153 99.3576 76.2003C98.4676 76.5413 82.0256 76.8213 62.8206 76.8213C29.2356 76.8213 27.8266 76.7453 25.9026 74.8213C24.6596 73.5783 23.9026 71.4883 23.9026 69.2983C23.9026 66.3003 26.3797 62.4643 40.5287 43.5483C49.6737 31.3233 57.8596 20.7593 58.7196 20.0713C60.9796 18.2663 66.3517 18.5353 68.6977 20.5713ZM95.9026 223.821V335.821H63.9026H31.9026V223.821V111.821H63.9026H95.9026V223.821ZM100.992 373.682C105.128 378.792 104.143 380.847 85.9286 405.111C76.5936 417.547 68.0727 428.195 66.9947 428.772C64.4077 430.156 60.7816 430.053 58.8386 428.539C55.4366 425.889 23.8106 382.609 23.2576 379.847C22.7796 377.456 23.2476 376.322 25.7456 373.824L28.8226 370.747L63.9517 371.034L99.0816 371.321L100.992 373.682Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.f46a2997010e74e6fc68467a79441539.svg";
export { ForwardRef as ReactComponent };